import { render, staticRenderFns } from "./ProjectCardPreviewDetails.vue?vue&type=template&id=1b6db68a"
import script from "./ProjectCardPreviewDetails.vue?vue&type=script&lang=js"
export * from "./ProjectCardPreviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports